import $Util from "../../components/util.js"
export default {
	state:{
		title:'',
    				category:[],
    				desc:'',
    				unit:'',
    				stock:0,
    				min_stock:0,
    				display_stock:0,
    				status:0,
    				express:'',
    				skus_type:0,
    				oprice:0, // 市场价格
					pprice:0, // 销售价格
					cprice:0, // 成本价格
					weight:0, // 重量
					volume:0, // 体积
					//规格卡片
					sku_card:[
					{
						name:"颜色",
						type:0,//0无 1颜色 2图片
						list:[
								{
									name:'黄色',
									image:"",
									color:""
								},
								{
									name:'红色',
									image:"",
									color:""
								}


						]
					},
					

					],

		user:{},
		token:false
	},
	getters:{
		
	},
	mutations:{

		vModelState(state,{key,value}){
			state[key] = value
			console.log(value)
		},
		addSkuCard(state){
			state.sku_card.push({
				name:'规格名称',
				type:0,
				list:[]
			})
		},
		addSkuVal(state,index){
			state.sku_card[index].list.push({
				name:'红色',
				image:"",
				color:""				
			})

		},
		delSkuVal(state,{cardIndex,valueIndex}){
			state.sku_card[cardIndex].list.splice(valueIndex,1)
		},
		delSkuCard(state,index){
			state.sku_card.splice(index,1)
		},
		// 修改规格卡片
		vModelSkuCard(state,{ key,index,value}){
			state.sku_card[index][key] = value
		},
		sortCard(state,{action,index}){
			$Util[action](state.sku_card,index)
		},
		
		// 初始化用户信息
		initUser(state){
			let user = window.sessionStorage.getItem('user')
			if(user){
				state.user = JSON.parse(user)
				state.token = state.user.token
			}
		},
		// 登录
		login(state,user){
			// 保存登录状态
			state.user = user
			//state.token = user.token
			// 存储到本地存储
			window.sessionStorage.setItem('user',JSON.stringify(state.user))
			//window.sessionStorage.setItem('token',JSON.stringify(state.token))
		},
		// 退出登录
		logout(state){
			// 清除状态
			state.user = {}
			//state.token = false
			// 清除本地存储
			window.sessionStorage.clear()
		}
	},
	actions:{
		
	}
}


// WEBPACK FOOTER //
// ./src/store/modules/user.js